/** Identity tints drawn from tokens that carry no money meaning (never income, expense or ok/danger). */
export const LEDGER_TONES = ['--color-accent', '--color-transfer', '--color-attention'] as const
export type LedgerTone = (typeof LEDGER_TONES)[number]

/** Derived from the ledger's id, so the colour is stable across sessions and never stored. */
export function ledgerToneFor(id: string): LedgerTone {
  let hash = 0
  for (const character of id) hash = (hash * 31 + character.charCodeAt(0)) >>> 0
  return LEDGER_TONES[hash % LEDGER_TONES.length]!
}
